import { createFileRoute } from "@tanstack/react-router";

import { prefetchForProject } from "../../../lib/prefetch";
import { JobsPage } from "../../../workspaces/training/pages/JobsPage";

export const Route = createFileRoute("/_console/p/$org/$project/training/")({
  loader: ({ context: { queryClient }, params }) =>
    prefetchForProject(
      queryClient,
      params,
      Promise.all([
        import("../../../workspaces/training/api/jobs"),
        import("../../../workspaces/training/queries"),
      ]),
      ([{ createTrainingJobsApi }, { trainingQueries }], projectId) => {
        const reads = trainingQueries(projectId, createTrainingJobsApi(projectId));
        void queryClient.prefetchQuery(reads.jobs);
        void queryClient.prefetchQuery(reads.data);
      },
    ),
  component: JobsPage,
});
